<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.invoicesAnalysis.totalItems / this.filters.pageSize
      );
    },
    invoices() {
      return this.$store.state.invoicesAnalysis.invoices;
    },
    invoiceTypes() {
      return  [
        { value: 0, label: "الكل" },
        ...this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.InvoiceTypes
      )];
    },
  },

  data() {
    return {
      permissions: this.$patientsManagementPermissions.analysisInvoicesPermissions,
      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        phoneNo: null,
        fullName: null,
        invoiceNo: null,
        appointmentDate: null,
        invoiceTypeId: 0,
      },
      headers: [
        { text: 'رقم الطلب ', value: 'orderReference' },
        { text: 'اسم المريض   ', value: 'fullName' },
        { text: 'التاريخ  ', value: 'appointmentDate' },
        { text: "حالة الطلب ", value: "status", sortable: false },
        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("invoicesAnalysis/getAll", this.filters);
    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    print(item) {
      this.itemId = item.id;
      const routeData = this.$router.resolve(
        `/invoicesAnalysis-print/${this.itemId}`
      );
      window.open(routeData.href, "_blank");
    }, 
   
  
    showDialog(item, type) {
      switch (type) {
        // case "delete":
        //   this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
        //   break;
        // case "approval":
        //   this.dialogMessage = "هل انت متأكد من رغبتك اعتماد البيانات";
        //   break;
          case "cancel":
          this.dialogMessage = "هل انت متأكد من رغبتك الغاء العملية";
          break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },
    handleClear() {
      this.filters.receivedDate = null;
    },
    confirmDialog() {
      this.$store.dispatch(`invoicesAnalysis/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>